module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload-page-1-container"
  }, [_c('modal', {
    staticStyle: {},
    attrs: {
      "height": 250,
      "pivotY": 0.5,
      "width": 300,
      "name": "add-new-ea-suggestion"
    }
  }, [_c('div', {
    staticClass: "text-xs-center add-tag-container"
  }, [_c('h3', [_vm._v("Type the tag name!")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "color": "#f5a623",
      "autofocus": true
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addTagToSelected('EA')
      }
    },
    model: {
      value: (_vm.addTagModal),
      callback: function($$v) {
        _vm.addTagModal = $$v
      },
      expression: "addTagModal"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "tag-add-button",
    on: {
      "click": function($event) {
        return _vm.addTagToSelected('EA')
      }
    }
  }, [_vm._v("Add Tag")])], 1)]), _vm._v(" "), _c('modal', {
    attrs: {
      "height": 250,
      "pivotY": 0.5,
      "width": 300,
      "name": "add-new-spot-suggestion"
    }
  }, [_c('div', {
    staticClass: "text-xs-center add-tag-container"
  }, [_c('h3', [_vm._v("Type the tag name!")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "color": "#f5a623",
      "autofocus": true
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addTagToSelected('Spot')
      }
    },
    model: {
      value: (_vm.addTagModal),
      callback: function($$v) {
        _vm.addTagModal = $$v
      },
      expression: "addTagModal"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "tag-add-button",
    on: {
      "click": function($event) {
        return _vm.addTagToSelected('Spot')
      }
    }
  }, [_vm._v("Add Tag")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "upload-screen-1-container"
  }, [_c('div', {
    staticClass: "text-xs-left"
  }, [_c('div', {
    staticClass: "actions"
  }, [_c('i', {
    staticClass: "material-icons white--text",
    staticStyle: {
      "font-size": "1.1em",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("arrow_back_ios")]), _vm._v(" "), _c('label', {
    staticClass: "upload-title"
  }, [_vm._v(_vm._s(_vm.$route.query.resourceType == "image" ? 'SUBMIT YOUR PHOTO' : 'SUBMIT YOUR VIDEO'))]), _vm._v(" "), _c('div', {
    staticClass: "tooltip"
  }, [_c('button', {
    staticClass: "done pointer",
    style: (!_vm.$store.state.uploadImage_3.geoLocIsAvailable_uploadImage_3 ? 'background-color:#5b5b5b;color: #9b9b9b' : 'background-color:#bd10e0;color: #ffffff'),
    attrs: {
      "disabled": !_vm.$store.state.uploadImage_3.geoLocIsAvailable_uploadImage_3 ? true : false
    },
    on: {
      "click": function($event) {
        _vm.shareUploadedImage({
          isBulk: false,
          photoId: _vm.$route.query.publicId,
          resourceType: _vm.$route.query.resourceType,
          monNDur: {
            mon: _vm._mon2,
            dur: _vm._dur2
          },
          anyoneCanVisitThisSpot: _vm.$store.state.uploadImage_4.anyoneCanVisitThisSpot_uploadImage,
          myPhoto: true,
          hasGeohash: _vm.$store.state.uploadImage_3.geoLocIsAvailable_uploadImage_3,
          uid: _vm.$store.state.auth.user.uid,
          uploader: 'user',
          caption: _vm.$store.state.uploadImage_2.caption_uploadImage,
          pic_desc: _vm.$store.state.uploadImage_3.travelInfo,
          emotionalAppeal: JSON.stringify(_vm.$store.state.uploadImage_2.selectedemotionalAppeal_uploadImage),
          keywords: JSON.stringify(_vm.$store.state.uploadImage_5.selectedKeywords_uploadImage),
          spotType: JSON.stringify(_vm.$store.state.uploadImage_4.selectedSpotType_uploadImage),
          photoSourceLink: _vm.$route.query.photoSourceLink,
          licenseType: '',
          licenseLink: '',
          allowCommercialUse: '',
          approved: false,
          geohash: _vm.$store.state.uploadImage_3.geohashVal,
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.$route.query.resourceType == "image" ? 'Submit this photo' : 'Submit this video'))]), _vm._v(" "), (!_vm.$store.state.uploadImage_3.geoLocIsAvailable_uploadImage_3) ? _c('span', {
    staticClass: "tooltiptext"
  }, [_vm._v(_vm._s(_vm.$route.query.resourceType == "image" ? 'Please select photo location first.' : 'Please select video location first'))]) : _vm._e()])])]), _vm._v(" "), _c('v-layout', {
    staticClass: "img-and-caption-container",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "img-container",
    attrs: {
      "xs4": "",
      "sm6": "",
      "md6": "",
      "lg6": ""
    }
  }, [(_vm.$route.query.resourceType == 'image') ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.uploadedImgUrl),
      expression: "uploadedImgUrl"
    }]
  }) : _vm._e(), _vm._v(" "), (_vm.$route.query.resourceType == 'video') ? _c('div', {
    staticClass: "video-container"
  }, [(_vm.$route.query.resourceType == 'video') ? _c('div', {
    staticClass: "video-player",
    staticStyle: {
      "position": "relative",
      "height": "100%",
      "width": "600px"
    }
  }, [(_vm.$route.query.photoSourceLink.includes('vimeo')) ? _c('iframe', {
    staticStyle: {
      "top": "0",
      "bottom": "0",
      "height": "90%",
      "width": "100%",
      "right": "0"
    },
    attrs: {
      "src": _vm.getVideoLink(_vm.$route.query.photoSourceLink),
      "frameborder": "0",
      "allow": "autoplay; fullscreen",
      "allowfullscreen": ""
    },
    on: {
      "load": function($event) {
        _vm.imgLoader = false
      }
    }
  }) : _c('youtube', {
    staticClass: "video-player-youtube",
    attrs: {
      "id": "yt_video",
      "video-id": _vm.getVideoId(_vm.$route.query.photoSourceLink),
      "player-width": "100%",
      "player-height": "90%"
    },
    on: {
      "pause": _vm.pause,
      "ready": _vm.ready,
      "playing": _vm.playing
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "location-piblic-access"
  }, [_c('div', {
    staticClass: "inner-container"
  }, [(!JSON.parse(_vm.$route.query.geoLocIsAvailable)) ? _c('div', {
    staticClass: "input-container white--text padding-bottom padding-top location-container"
  }, [(_vm.locationAddress.length !== 0) ? _c('div', {
    staticClass: "input-container-text"
  }, [_c('button', {
    staticClass: "add-location",
    on: {
      "click": function($event) {
        _vm.$modal.show('mapModal');
        _vm.$store.state.uploadImage_2.openMapDialog = true
      }
    }
  }, [_vm._v("\n                  Change photo location\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "address",
    staticStyle: {
      "font-size": "12px",
      "margin-top": "2px"
    }
  }, [_vm._v(_vm._s(_vm.locationAddress))])]) : _c('div', {
    staticClass: "location-button"
  }, [_c('button', {
    staticClass: "add-location-new",
    on: {
      "click": function($event) {
        _vm.$modal.show('mapModal');
        _vm.$store.state.uploadImage_2.openMapDialog = true
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$route.query.resourceType == "image" ? 'Select photo location' : 'Select video location') + "\n                ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-container public-spot-container"
  }, [_c('label', {
    staticClass: "container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.uploadImage_4.anyoneCanVisitThisSpot_uploadImage),
      expression: "$store.state.uploadImage_4.anyoneCanVisitThisSpot_uploadImage"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.$store.state.uploadImage_4.anyoneCanVisitThisSpot_uploadImage) ? _vm._i(_vm.$store.state.uploadImage_4.anyoneCanVisitThisSpot_uploadImage, null) > -1 : (_vm.$store.state.uploadImage_4.anyoneCanVisitThisSpot_uploadImage)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.$store.state.uploadImage_4.anyoneCanVisitThisSpot_uploadImage,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.$store.state.uploadImage_4, "anyoneCanVisitThisSpot_uploadImage", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.$store.state.uploadImage_4, "anyoneCanVisitThisSpot_uploadImage", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.$store.state.uploadImage_4, "anyoneCanVisitThisSpot_uploadImage", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-label heading-text"
  }, [_vm._v("Public spot")]), _vm._v(" "), _c('div', {
    staticClass: "input-container-text white--text sub-text"
  }, [_vm._v("Photo is NOT taken from a private property")])])])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "caption-container",
    attrs: {
      "xs8": "",
      "sm6": "",
      "md6": "",
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "caption-title"
  }, [_vm._v("Give it a beautiful caption")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.uploadImage_2.caption_uploadImage),
      expression: "$store.state.uploadImage_2.caption_uploadImage"
    }],
    staticClass: "caption-text-area",
    attrs: {
      "placeholder": "Start typing here ..."
    },
    domProps: {
      "value": (_vm.$store.state.uploadImage_2.caption_uploadImage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.uploadImage_2, "caption_uploadImage", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-container"
  }, [_c('div', {
    staticClass: "input-label text-xs-left"
  }, [_vm._v("Describe the feel of this place")]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-left white--text selected-tags-upload"
  }, [_c('div', {
    staticClass: "selected-suggestions"
  }, [(_vm.$store.state.uploadImage_2.selectedemotionalAppeal_uploadImage.length != 0) ? _c('div', _vm._l((_vm.$store.state.uploadImage_2.selectedemotionalAppeal_uploadImage), function(selected_suggestion, sIndex) {
    return _c('label', {
      key: ("" + sIndex)
    }, [_vm._v(_vm._s(selected_suggestion) + _vm._s(sIndex === _vm.$store.state.uploadImage_2.selectedemotionalAppeal_uploadImage.length - 1 ? '' : ', '))])
  }), 0) : _c('div', [_c('label', {
    staticClass: "selected-tags-placeholder"
  }, [_vm._v("Select below or add new...")])])])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "flex-grow-1": ""
    }
  }, [_c('div', {
    staticClass: "suggestions-container",
    attrs: {
      "id": "selected-emotional-appeal"
    }
  }, _vm._l((this.vibeSuggestions), function(suggestion, sIndex) {
    return _c('div', {
      key: ("" + sIndex),
      staticClass: "unselected-suggestion-pills pointer",
      attrs: {
        "id": ("ea" + sIndex)
      },
      on: {
        "click": function($event) {
          return _vm.addOrRemove(suggestion, 'EA', ("ea" + sIndex))
        }
      }
    }, [_vm._v(_vm._s(suggestion))])
  }), 0)]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "add-new-btn-suggestion pointer",
    on: {
      "click": function($event) {
        return _vm.$modal.show('add-new-ea-suggestion')
      }
    }
  }, [_vm._v("Add new")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "input-container"
  }, [_c('div', {
    staticClass: "input-label text-xs-left"
  }, [_vm._v("This photo was taken from …")]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-left white--text selected-tags-upload"
  }, [_c('div', {
    staticClass: "selected-suggestions",
    attrs: {
      "id": "selected-spot-types"
    }
  }, [(_vm.$store.state.uploadImage_4.selectedSpotType_uploadImage.length != 0) ? _c('div', _vm._l((_vm.$store.state.uploadImage_4.selectedSpotType_uploadImage), function(selected_suggestion, sIndex) {
    return _c('label', {
      key: ("" + sIndex)
    }, [_vm._v(_vm._s(selected_suggestion) + _vm._s(sIndex === _vm.$store.state.uploadImage_4.selectedSpotType_uploadImage.length - 1 ? '' : ', '))])
  }), 0) : _c('div', [_c('label', {
    staticClass: "selected-tags-placeholder"
  }, [_vm._v("Select below or add new...")])])])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "flex-grow-1": ""
    }
  }, [_c('div', {
    staticClass: "suggestions-container"
  }, _vm._l((this.spotSuggestions), function(suggestion, sIndex) {
    return _c('div', {
      key: ("" + sIndex),
      staticClass: "unselected-suggestion-pills pointer",
      attrs: {
        "id": ("s" + sIndex)
      }
    }, [_c('button', {
      on: {
        "click": function($event) {
          return _vm.addOrRemove(suggestion, 'spot', ("s" + sIndex))
        }
      }
    }, [_vm._v(_vm._s(suggestion))])])
  }), 0)]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "add-new-btn-suggestion pointer",
    on: {
      "click": function($event) {
        return _vm.$modal.show('add-new-spot-suggestion')
      }
    }
  }, [_vm._v("Add new")])])], 1)], 1), _vm._v(" "), (_vm.$route.query.createdAt == '') ? _c('div', {
    staticClass: "image-datetime-upload-heading"
  }, [_vm._v("When was this photo taken?")]) : _vm._e(), _vm._v(" "), (_vm.$route.query.createdAt == '') ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-dialog', {
    ref: "dialog1",
    attrs: {
      "return-value": _vm.date,
      "persistent": "",
      "width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('div', {
          staticStyle: {
            "display": "flex"
          }
        }, [_c('div', _vm._g(_vm._b({
          staticClass: "date-time-input-box",
          style: (_vm.date == '' ? 'color:#b9b9b9' : 'color:#f5a623')
        }, 'div', attrs, false), on), [_vm._v(_vm._s(_vm.date == '' ? 'Select a date' : _vm.date))]), _vm._v(" "), _c('div', _vm._g(_vm._b({}, 'div', attrs, false), on), [_c('i', {
          staticClass: "material-icons",
          staticStyle: {
            "cursor": "pointer",
            "color": "white"
          }
        }, [_vm._v("calendar_today")])])])]
      }
    }], null, false, 3036176884),
    model: {
      value: (_vm.modal),
      callback: function($$v) {
        _vm.modal = $$v
      },
      expression: "modal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "max": _vm.currentDate,
      "scrollable": ""
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.modal = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dialog1.save(_vm.date)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', [_c('v-dialog', {
    ref: "dialog",
    attrs: {
      "return-value": _vm.time,
      "persistent": "",
      "width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.time = $event
      },
      "update:return-value": function($event) {
        _vm.time = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('div', {
          staticStyle: {
            "display": "flex"
          }
        }, [_c('div', _vm._g(_vm._b({
          staticClass: "date-time-input-box",
          style: (_vm.time == '' ? 'color:#b9b9b9' : 'color:#f5a623')
        }, 'div', attrs, false), on), [_vm._v(_vm._s(_vm.time == '' ? 'Select a time' : _vm.time))]), _vm._v(" "), _c('div', _vm._g(_vm._b({
          staticStyle: {
            "cursor": "pointer",
            "color": "white"
          }
        }, 'div', attrs, false), on), [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("access_time")])])]), _vm._v(" "), _c('p', {
          staticStyle: {
            "visibility": "hidden"
          }
        }, [_vm._v(_vm._s(_vm.submittableDateTime))])]
      }
    }], null, false, 270264626),
    model: {
      value: (_vm.modal2),
      callback: function($$v) {
        _vm.modal2 = $$v
      },
      expression: "modal2"
    }
  }, [_vm._v(" "), (_vm.modal2) ? _c('v-time-picker', {
    attrs: {
      "format": "24hr",
      "full-width": ""
    },
    model: {
      value: (_vm.time),
      callback: function($$v) {
        _vm.time = $$v
      },
      expression: "time"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.modal2 = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dialog.save(_vm.time)
      }
    }
  }, [_vm._v("OK")])], 1) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('modal', {
    staticClass: "mapModal",
    attrs: {
      "name": "mapModal",
      "width": "60%",
      "height": "auto"
    },
    on: {
      "closed": function($event) {
        _vm.$store.state.uploadImage_2.openMapDialog = false
      }
    }
  }, [_c('div', {
    staticClass: "white"
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.imageLocation),
      expression: "imageLocation"
    }],
    staticClass: "map-input-box",
    attrs: {
      "id": "pac-input",
      "placeholder": "Search location here..."
    },
    domProps: {
      "value": (_vm.imageLocation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.imageLocation = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "blue--text my-loc-btn",
    attrs: {
      "id": "locBut"
    },
    on: {
      "click": _vm.getCurrentGeoLocation
    },
    nativeOn: {
      "click": function($event) {
        _vm.$store.state.uploadImage_3.getCenter = true
      }
    }
  }, [_c('v-icon', [_vm._v("location_searching")])], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "myMap"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    },
    on: {
      "mouseenter": function($event) {
        return _vm.showMapTooltip()
      },
      "mouseleave": function($event) {
        return _vm.hideMapTooltip()
      }
    }
  }, [_c('button', {
    class: _vm.imageLocation === '' ? 'select-loc-btn-disabled' : 'select-loc-btn',
    attrs: {
      "disabled": _vm.imageLocation === '' ? true : false
    },
    on: {
      "click": function($event) {
        return _vm.selectMarkerLocation()
      }
    }
  }, [_vm._v("SELECT THIS LOCATION")]), _vm._v(" "), (_vm.imageLocation === '' ? _vm.mapTooltip : '') ? _c('span', {
    staticClass: "map-tooltiptext"
  }, [_vm._v(_vm._s(_vm.$route.query.resourceType == "image" ? 'Please select photo location first.' : 'Please select video location first'))]) : _vm._e()])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20ab93f1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/uploadImage/uploadImage_2.vue
// module id = 831
// module chunks = 6